/**
 * useRamadan — returns true if current date falls within Ramadan.
 *
 * Ramadan date ranges (approximate, Gregorian).
 * Dates come from Umm al-Qura / widely accepted Islamic calendars.
 * Kept as a simple static table so we don't depend on an external API.
 */
const RAMADAN_RANGES = [
  { start: "2025-03-01", end: "2025-03-30" },
  { start: "2026-02-17", end: "2026-03-19" },
  { start: "2027-02-07", end: "2027-03-08" },
  { start: "2028-01-27", end: "2028-02-25" },
  { start: "2029-01-15", end: "2029-02-13" },
  { start: "2030-01-04", end: "2030-02-02" },
];

export function useRamadan() {
  const today = new Date();
  const ymd = today.toISOString().slice(0, 10);
  return RAMADAN_RANGES.some((r) => ymd >= r.start && ymd <= r.end);
}
